<template>
  <div class="sign-act" v-if="actInfo">
    <header>
      <div class="s-t">
        <img :src="`${CDN_URL}/back.png`" alt="" />
        <span>{{ actInfo.title }}</span>
      </div>
    </header>
    <main>
      <div class="account">
        <p class="account" v-if="userInfo.game_account || globalUserInfo.game_account">
          已绑定账号：<span>{{ userInfo.game_account || globalUserInfo.game_account }}</span>
          <span class="ml_8 color_link" @click="onLogswitch">切换账号</span>
        </p>
        <p v-else class="account"></p>
        <div class="rule">
          <img :src="`${CDN_URL}/limiteAct/18.png`" alt="">
          <span @click="showRule">活动规则</span>
        </div>
      </div>
      <div class="icon-list gameCenter">
        <div class="title">
          <img :src="`${CDN_URL}/limiteAct/20.png`"  alt="">
          <span class="title">限时礼包</span>
          <span class="desc">每{{ limit }}领取，还有<span>{{ surplus_day }}</span>天开放领取</span>
        </div>
        <div
          :style="{ backgroundImage: `url('${item.images}')` }"
          v-for="(item, index) in firstPageInfo"
          :key="index"
          :class="[actGame.id === item.id ? 'active' : '', 'gi']"
          @click="selectGame(item)"
        >
          <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="actGame.id === item.id" />
        </div>
        <div class="more" @click="moreGameVisible=true">
          <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="isMoreGame" class="active">
          <img :src="`${CDN_URL}/signAct/1.png?v=1`" alt="" />
          <p>更多游戏</p>
        </div>
      </div>
      <div class="welfare">
        <header>
          <span>{{ actGame.name }}</span>
          <span @click="showRecord">礼包领取记录></span>
        </header>
        <ul>
          <li v-for="(item, index) in welList" :key="index">
            <img :src="item.icon" alt="" />
            <div>
              <p>{{ item.welfare_name }}</p>
              <p>{{ item.description }}</p>
            </div>
            <button v-if="item.can_get == 1" @click="receiveGift(item)">领取</button>
            <button v-if="item.can_get == 3" class="hasGet" @click="receiveGift(item)">未开放</button>
            <button v-if="item.can_get == 2" class="hasGet" @click="receiveGift(item, 1)">已领取</button>
          </li>
        </ul>
      </div>
      <div class="tweet">
        <div class="title">
          <img :src="`${CDN_URL}/limiteAct/21.png?v=1`" alt="">
          <span>限时活动</span>
        </div>
        <ul>
          <li v-for="(item, index) in tweetData" :key="index" @click="openTweet(item)">
            <img :src="item.tweet_image" alt="">
            <div class="end" v-if="item.tweet_state == 2">
              活动已结束！
            </div>
            <div class="info">
              <div class="text">
                <span>{{ item.tweet_title }}</span>
                <span>{{ moment(item.start_time).format('YYYY-MM-DD') }}-{{ moment(item.end_time).format('YYYY-MM-DD') }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </main>
    <!-- 弹框 -->
    <CustomDialogWrapper
      @closeDialog="dialogShow = false"
      v-show="dialogShow"
      class="customDialogWrapper"
    >
      <template #title>
        <p class="title" v-show="dialogType == 2">领取成功</p>
      </template>
      <template #main-content>
        <p class="content" v-show="dialogType == 1">
          领取礼包需激活对应游戏，您尚未激活该游戏，下载并进入游戏即可激活
        </p>
        <p class="content code" v-show="dialogType == 2">激活码：{{ giftCode }}</p>
        <p class="h-content" v-show="dialogType == 2">礼包有时间限制，请及时前往游戏中兑换</p>
        <p
          class="content"
          v-show="dialogType == 3"
          v-html="actInfo.rules_info.replaceAll('\n', '<br>')"
        ></p>
      </template>
      <template #footer>
        <button class="btn-cancel" type="info" @click="dialogShow = false" v-show="dialogType == 1">
          再逛逛
        </button>
        <button class="btn-submit" type="info" @click="downloadGame" v-show="dialogType == 1">
          下载游戏
        </button>
        <button
          :data-clipboard-text="giftCode"
          class="btn-submit"
          type="info"
          v-show="dialogType == 2"
          @click="copyData"
        >
          点击复制
        </button>
      </template>
    </CustomDialogWrapper>
    <!-- 选择更多游戏 -->
    <div class="more-game" v-if="moreGameVisible">
      <div class="content">
        <header>
          <span>请选择</span>
          <img :src="`${CDN_URL}/tgStore/close.png`" alt="" @click="moreGameVisible = false" />
        </header>
        <main>
          <p v-if="moreGame.online && moreGame.online.length">在玩游戏</p>
          <div
            v-if="moreGame.online"
            v-for="(item, index) in moreGame.online"
            :key="index"
            class="games"
            @click="selectGame(item)"
          >
            <img :src="item.images" alt="" />
            <p>{{ item.name }}</p>
          </div>
          <p v-if="moreGame.games && moreGame.games.length">推荐游戏</p>
          <div
            v-if="moreGame.games"
            v-for="(item, index) in moreGame.games"
            :key="index"
            class="games"
            @click="selectGame(item)"
          >
            <img :src="item.images" alt="" />
            <p>{{ item.name }}</p>
          </div>
        </main>
      </div>
    </div>
    <!-- 礼包领取记录 -->
    <div class="record" v-if="recordVisible">
      <header>
        <img :src="`${CDN_URL}/back.png`" alt="" @click="recordVisible = false" />
        <span>礼包领取记录</span>
      </header>
      <div class="icon-list">
        <div
          :style="{ backgroundImage: `url('${item.images}')` }"
          v-for="(item, index) in firstPageInfo"
          :key="index"
          :class="[actGame.id === item.id ? 'active' : '', 'gi']"
          @click="selectGame(item)"
        >
          <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="actGame.id === item.id" />
        </div>
        <div class="more" @click="moreGameVisible = true">
          <img :src="`${CDN_URL}/signAct/9.png?v=1`" alt="" v-if="isMoreGame" class="active" />
          <img :src="`${CDN_URL}/signAct/1.png?v=1`" alt="" />
          <p>更多游戏</p>
        </div>
      </div>
      <main>
        <ul>
          <li v-for="(item, index) in recordList" :key="index">
            <div>
              <img :src="item.icon" alt="" />
              <div>
                <p>{{ item.welfare_name }}</p>
                <p>{{ item.description }}</p>
              </div>
              <button :data-clipboard-text="item.code" class="gift-copy">复制</button>
            </div>
            <p>领取时间：{{ item.get_time }}</p>
          </li>
        </ul>
        <Pagination
          v-if="recordTotal"
          v-model="recordPage"
          :total-items="recordTotal"
          :items-per-page="10"
          @change="pageChange"
        ></Pagination>
        <div v-else class="nodata">暂无数据</div>
      </main>
    </div>
  </div>
</template>
<script>
import { CDN_URL } from '@/config/index.js';
import {
  actInfoApi,
  userInfoApi,
  firstPageApi,
  moreGameApi,
  welfareApi,
  getWelfareApi,
  receiveApi,
  tweetApi,
  burnReport
} from '@/api/limitAct';
import { mapState, mapMutations } from 'vuex';
import CustomDialogWrapper from '@/components/CustomDialogs/CustomDialogWrapper';
import Clipboard from 'clipboard';
import { Pagination } from 'vant';
import moment from 'moment';
import bindAccountMixin from '@/mixins/bindAccountMixin.js'

export default {
  mixins: [bindAccountMixin],
  data() {
    return {
      moment,
      CDN_URL,
      dtd: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      actId: '',
      actInfo: {
        title: '限时福利',
        rules_info: ''
      },
      userInfo: {},
      firstPageInfo: [],
      moreGame: {},
      welId: '',
      welList: [],
      actGame: {},
      dialogShow: false,
      dialogType: 1, // 1.不符合条件 2.领取成功 3.活动规则
      giftCode: '',
      download_url: '',
      firstPageIds: [],
      isMoreGame: false,
      moreGameVisible: false,
      recordVisible: false,
      recordList: [],
      giftCopy: null,
      recordTotal: 0,
      recordPage: 1,
      tweetData: [],
      surplus_day: '',
      limit: ''
    };
  },
  mounted() {
    this.getBaseInfo();
    this.getTweet();
    this.copyInit();
  },
  computed: {
    ...mapState('account', {
      globalUserInfo: (state) => state.userInfo,
    }),
  },
  methods: {
    copyData() {
      burnReport({
        type: 19,
        data_type: 7,
        overall_id: this.actId,
        welfare_id: this.welId,
        game_venue_id: this.actGame.game_id
      })
    },
    openTweet(item) {
      burnReport({
        type: 19,
        data_type: 4,
        overall_id: this.actId,
        tweet_id: item.id,
      })
      if (item.tweet_state == 2) {
        return;
      }
      setTimeout(() => {
        location.href = item.url;   
      }, 200)
    },
    async getTweet() {
      const r = await tweetApi(this.$route.query.id);
      this.tweetData = r.data;
    },
    async receiveGift(item, type) {
      if (!this.userInfo.game_account && !this.globalUserInfo.game_account) {
        this.CHANGE_BIND_ACCOUNT_DIALOG(true);
        return;
      }
      this.welId = item.id;
      this.hasReceive = type;
      if (type) {
        this.giftCode = item.gift_code;
        this.dialogShow = true;
        this.dialogType = 2;
        return;
      }
      try {
        const r = await getWelfareApi(this.actId, {
          game_id: this.actGame.game_id,
          welfare_id: item.id,
        });
        if (r.data.code) {
          this.giftCode = r.data.code;
          this.dialogShow = true;
          this.dialogType = 2;
          this.getWelfare(this.actGame);
        }
      } catch (error) {
        if (error.code && error.code == 7) {
          this.download_url = error.data.download_url;
          this.dialogShow = true;
          this.dialogType = 1;
        } else {
          this.$toast(error.message);
        }
      }
    },
    showRule() {
      this.dialogShow = true;
      this.dialogType = 3;
    },
    copyInit() {
      // 领取游戏礼包弹窗中的点击复制
      this.copy = new Clipboard('.btn-submit');
      this.copy.on('success', (e) => {
        this.$toast.success('复制成功');
      });
    },
    downloadGame() {
      burnReport({
        type: 19,
        data_type: 6,
        overall_id: this.actId,
        game_venue_id: this.actGame.game_id,
        welfare_id: this.welId || null
      })
      setTimeout(() => {
        window.open(this.download_url);
      }, 500);
    },
    selectGame(item) {
      burnReport({
        type: 19,
        data_type: 2,
        overall_id: this.actId,
        game_venue_id: item.game_id,
      })
      this.actGame = item;
      this.moreGameVisible = false;
      this.isMoreGame = !this.firstPageIds.includes(item.id);
      this.getWelfare(item);
      this.recordPage = 1;
      this.getRecord(item.game_id);
    },
    async getBaseInfo() {
      this.actId = this.$route.query.id;
      // if (!this.actId) this.$router.replace({ path: '/' });
      burnReport({
        type: 19,
        data_type: 1,
        overall_id: this.actId
      })
      try {
        const r = await actInfoApi(this.actId);
        this.actInfo = r.data;
        // if (!this.actInfo.id) this.$router.replace({ path: '/' });
      } catch (error) {}
      this.getUserInfo();
      try {
        const r = await firstPageApi(this.actId);
        this.firstPageInfo = r.data;
        if (this.firstPageInfo.length) {
          this.firstPageIds = this.firstPageInfo.map((item) => item.id);
          this.actGame = this.firstPageInfo[0];
          this.getWelfare(this.firstPageInfo[0]);
        }
      } catch (error) {}
      try {
        const r = await moreGameApi(this.actId);
        this.moreGame = r.data;
      } catch (error) {}
    },
    async getUserInfo() {
      try {
        const r = await userInfoApi(this.actId);
        this.userInfo = r.data;
      } catch (error) {}
    },
    async getWelfare(game) {
      const r = await welfareApi(this.actId, { game_id: game.game_id });
      this.welList = r.data.list;
      this.surplus_day = r.data.surplus_day;
      this.limit = this.dtd[r.data.limit - 1];
    },
    showRecord() {
      this.recordPage = 1;
      this.getRecord(this.actGame.game_id);
      this.recordVisible = true;
    },
    pageChange() {
      this.getRecord(this.actGame.game_id);
    },
    async getRecord(game_id) {
      const r = await receiveApi(this.actId, {
        game_id: game_id,
        page: this.recordPage,
      });
      if (!r.data.data) {
        this.recordList = [];
        this.recordTotal = 0;
        return;
      }
      this.recordList = r.data.data;
      this.recordTotal = r.data.total;
      setTimeout(() => {
        if (this.giftCopy) this.giftCopy.destroy();
        this.giftCopy = new Clipboard('.gift-copy');
        this.giftCopy.on('success', (e) => {
          this.$toast.success('复制成功');
        });
      }, 500);
    },
    onChangeAccount () {
      this.getBaseInfo()
    },
  },
  components: {
    CustomDialogWrapper,
    Pagination,
  },
};
</script>
<style scoped lang="scss">
@import '~@/styles/_variable.scss';
.sign-act {
  position: relative;
  width: 375px;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  > header {
    width: 100%;
    position: relative;
    z-index: 2;
    background-color: #FFFFFF;
    .s-t {
      position: relative;
      width: 100%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      font-size: 19px;
      > img {
        position: absolute;
        left: 5px;
        width: 18px;
      }
    }
  }
  > main {
    padding: 7px 10px;
    > .account {
      display: inline-block;
      background-color: #FFFFFF;
      width: 100%;
      border-radius: 7px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      padding: 10px;
      margin-bottom: 8px;
      > .account {
        color: #6D6D6D;
        > span {
          color: #FF7E30;
        }
      }
      > .rule {
        color: #B5B5B5;
        > img {
          width: 12px;
          height: 12px;
        }
        > span {
          text-decoration: underline;
        }
      }
    }
    .welfare {
      background-color: #FFFFFF;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      > header {
        display: flex;
        justify-content: space-between;
        padding: 10px 10px;
        > span:nth-child(1) {
          border-left: 3px solid #ef3144;
          font-size: 13px;
          color: #333333;
          padding-left: 7px;
        }
        > span:nth-child(2) {
          font-size: 12px;
          color: #fc5f5e;
        }
      }
      > ul {
        > li {
          width: 353px;
          background: #ffffff;
          border-radius: 7px;
          padding: 8px 12px;
          display: flex;
          align-items: center;
          margin: auto;
          margin-bottom: 6px;
          position: relative;
          > img {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            margin-right: 14px;
          }
          > div {
            > p:nth-child(1) {
              color: #333333;
              font-size: 13px;
              font-weight: 700;
              margin-bottom: 7px;
            }
            > p:nth-child(2) {
              color: #9f7155;
              font-size: 10px;
              line-height: 13px;
              width: 180px;
            }
          }
          > button {
            width: 81px;
            height: 30px;
            background: #ff5043;
            border-radius: 15px;
            outline: none;
            border: none;
            color: #ffffff;
            font-size: 13px;
            &.hasGet {
              background: #919191;
            }
          }
        }
      }
    }
    .tweet {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 58px 15px 8px;
      background-color: #ffffff;
      position: relative;
      > .title {
        position:absolute;
        top: 0;
        width: 100%;
        height: 50px;
        background: linear-gradient(0deg,#fcf6e3 0%, rgba(252,246,227,0.00) 100%);
        display: flex;
        align-items: center;
        padding: 0 15px;
        font-size: 16px;
        font-weight: bold;
        > span {
          color: #333333;
          font-size: 16px;
          line-height: 24px;
          font-weight: 700;
        }
        > img {
          width: 22px;
          height: 22px;
          margin-right: 10px;
        }
      }
      > ul {
        > li {
          position: relative;
          border-radius: 8px;
          width: 340px;
          height: 170px;
          margin-bottom: 10px;
          > img {
            border-radius: 8px;
            width: 340px;
            height: 170px;
          }
          .end {
            background-color: rgba(0, 0, 0, 0.4);
            color: #FFFFFF;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .info {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            color: #FFFFFF;
            .text {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              display: flex;
              justify-content: space-between;
              font-size: 12px;
              padding: 10px;
            }
            &.active {
              background-color: rgba(0, 0, 0, 0.4);  
            } 
          }
        }
      }
    }
  }
}

.customDialogWrapper {
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  .title {
    color: #333333;
    font-size: 18px;
    line-height: 24px;
    font-weight: 700;
  }
  .content {
    color: #686868;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
  }
  .code {
    text-align: center;
    margin-top: 20px;
    font-size: 15px;
    color: #333333;
  }
  .h-content {
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
    color: #ff5043;
  }
  .btn-cancel,
  .btn-submit {
    width: 101px;
    height: 30px;
    background: #ff5043;
    border-radius: 15px;
    outline: none;
    border: none;
    color: #ffffff;
    font-size: 14px;
    margin: 0 10px;
  }
  .btn-cancel {
    background-color: #919191;
  }
}

.more-game {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 100;
  .content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 305px;
    height: 376px;
    background: #ffffff;
    border-radius: 8px;
    margin: auto;
    > header {
      width: 305px;
      height: 36px;
      background: #ff7f27;
      border-radius: 8px 8px 0px 0px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      > img {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 12px;
        height: 12px;
      }
    }
    > main {
      height: calc(100% - 36px);
      overflow-y: auto;
      > p {
        font-size: 19px;
        color: #ff5216;
        padding: 18px 20px;
      }
      .games {
        display: inline-block;
        width: 100px;
        height: 100px;
        text-align: center;
        > img {
          display: inline-block;
          width: 60px;
          height: 60px;
          border-radius: 6px;
          margin-bottom: 4px;
        }
        > p {
          color: #333333;
          font-size: 12px;
        }
      }
    }
  }
}

.icon-list {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 15px 8px;
  background-color: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: relative;
  &.gameCenter {
    padding-top: 58px;
  }
  > .title {
    position:absolute;
    top: 0;
    width: 100%;
    height: 50px;
    background: linear-gradient(0deg,#fcf6e3 0%, rgba(252,246,227,0.00) 100%);
    display: flex;
    align-items: center;
    padding: 0 15px;
    > img {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
    > .title {
      font-size: 16px;
      font-weight: bold;
    }
    > .desc {
      font-size: 12px;
      color: #9F9F9F;
      margin-top: 5px;
      margin-left: 10px;
      > span {
        color: #FC5F5E;
      }
    }
  }
  > .gi {
    width: 54px;
    height: 54px;
    border-radius: 12px;
    margin-right: 14px;
    background-size: 100% 100%;
    &.active {
      width: 68px;
      height: 68px;
      position: relative;
      border-radius: 16px;
    }
    > img {
      width: 100%;
      height: 100%;
    }
  }
  > .more {
    position: relative;
    margin-left: 5px;
    > img {
      display: block;
      width: 37px;
      height: 37px;
      margin-bottom: 5px;
      &.active {
        position: absolute;
        top: -9px;
        left: -13px;
        width: 65px;
        height: 65px;
      }
    }
    > p {
      font-size: 9px;
      text-align: center;
      color: #fc5f5e;
    }
  }
}

.record {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f8f8f8;
  z-index: 99;
  > header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    font-size: 18px;
    font-weight: 700;
    background-color: #ffffff;
    position: relative;
    margin-bottom: 8px;
    > img {
      position: absolute;
      left: 10px;
      width: 15px;
    }
  }
  > main {
    height: calc(100% - 145px);
    overflow: auto;
    padding: 0 11px;
    > ul {
      margin-top: 10px;
      > li {
        width: 353px;
        background: #ffffff;
        border-radius: 7px;
        padding: 8px 12px;
        margin: auto;
        margin-bottom: 6px;
        > div {
          display: flex;
          align-items: center;
          margin-bottom: 11px;
          > img {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            margin-right: 14px;
          }
          > div {
            > p:nth-child(1) {
              color: #333333;
              font-size: 13px;
              font-weight: 700;
              margin-bottom: 7px;
            }
            > p:nth-child(2) {
              color: #9f7155;
              font-size: 10px;
              line-height: 13px;
              width: 180px;
            }
          }
          > button {
            width: 71px;
            height: 30px;
            background: #ff5043;
            border-radius: 15px;
            outline: none;
            border: none;
            color: #ffffff;
            font-size: 14px;
            &.hasGet {
              background: #919191;
            }
          }
        }
        > p {
          font-size: 10px;
          color: #fc5f5e;
        }
      }
    }
  }
  .nodata {
    text-align: center;
    color: #cccccc;
    margin-top: 10px;
  }
}
</style>
<style lang="scss">
.sign-act {
  .van-pagination__item {
    color: #fc5f5e;
  }
  .van-pagination__item--active {
    background-color: #fc5f5e;
    color: #ffffff;
  }
}
</style>
